// Regular Expression for PostCode
// tslint:disable-next-line:max-line-length [POSTCODE Regex by UK Gov]
// const postCodeRegex = new RegExp('^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$');
// TODO: Temporary using this Regex as per discussion with Pankaj and Dhruba, Ideally regex not allowing part of post code, should be used.
// tslint:disable-next-line:max-line-length [THIS WILL ALLOW RG12 LIKE POST CODE ALSO. CASE INSENSITIVE & MIDDLE SPACE IS OPTIONAL]
// const postCodeRegex = /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) {0,1}([0-9][A-Za-z]{2}){0,1})$/ig;
// tslint:disable-next-line:max-line-length [THIS WILL NOT ALLOW RG12 LIKE POST CODE. CASE INSENSITIVE & MIDDLE SPACE IS OPTIONAL]
// const postCodeRegex = /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) ?([0-9][A-Za-z]{2}))/ig;

// partial UK postcode check
// tslint:disable-next-line:max-line-length
const postCodeRegex = /^(([gG][iI][rR] {0,}0[aA]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y])))( {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2})?))$/ig;

// Regular Expression for SortCode
// const sortCodeRegex = new RegExp('(\d){2}-(\d){2}-(\d){2}');
const sortCodeRegex = /^(?!(?:0{6}|00-00-00))(?:\d{6}|\d\d-\d\d-\d\d)$/;
// REGEX used for EMail : "/^\w+([.-]?\w+)'&#64;'\w+([.-]?\w+)(.\w{2,3})+$‌​/"
const emailRegex = new RegExp('[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*');

export class RegExpHelper {

  // To check whether user message contains any post code.
  public isPostCode(textToCheck: string): boolean {
    return textToCheck ? new RegExp(postCodeRegex).exec(textToCheck.toString()) !== null : false;
  }

  // To check whether user message contains any sort code.
  public isSortCode(textToCheck: string): boolean {
    return textToCheck ? new RegExp(sortCodeRegex).exec(textToCheck.toString()) !== null : false;
  }

  // To check whether string is an email.
  public isEmail(textToCheck: string): boolean {
    return textToCheck ? emailRegex.test(textToCheck.toString()) : false;
  }

}
